export default "__VITE_ASSET__CmUqxWW0__"